module.exports = __webpack_public_path__ + "media/images/Why_List_Your_Practice_With Us-1c6d6eda08397d75b0c62f3d479b7928.svg";